var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitterX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=X, theme=original brand, state=default",
    transform: "matrix(1, 0, 0, 1, 4, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M2.59325 0H21.4067C22.8389 0 24 1.16108 24 2.59325V21.4067C24 22.8389 22.8389 24 21.4067 24H2.59325C1.16108 24 0 22.8389 0 21.4067V2.59325C0 1.16108 1.16108 0 2.59325 0ZM10.8481 13.8617L15.308 20.3525H20.1788L13.5558 10.7139H13.5562L19.6458 3.63521H18.2026L12.9152 9.78152L8.69203 3.63521H3.82122L10.2073 12.9295L3.82122 20.3525H5.26435L10.8481 13.8617ZM18.2034 19.3154L12.8025 11.5902L12.1555 10.6649L8.00078 4.72158H5.78425L10.9326 12.0859L11.5797 13.0113V13.0117L15.9869 19.3154H18.2034Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitterX);
export default __webpack_public_path__ + "static/media/icon-twitter-x.143937a3402e21c49002c98e3eacf8d6.svg";
export { ForwardRef as ReactComponent };